import { EVENTS } from './events'

export const HOTJAR_EVENTS = {
  [EVENTS.PRICE_PAGE_VIEW]: 'Pricing Page View',
  [EVENTS.PURCHASE_CLICK]: 'Purchase Click',
  [EVENTS.SIGN_UP_PAGEVIEW]: 'Sign Up Pageview',
  [EVENTS.SIGN_UP_SUCCESS]: 'Sign Up Success',
  [EVENTS.SIGN_IN_PAGEVIEW]: 'Sign in Pageview',
  [EVENTS.SIGN_IN_SUCCESS]: 'Sign in Success',
  [EVENTS.PLAN_SELECT_CLICK]: 'Plan Select Click',
  [EVENTS.CHECKOUT_VIEW]: 'Checkout View',
  [EVENTS.NEW_CHECKOUT_MODAL_VIEW]: 'New Checkout Modal View',
  [EVENTS.NEW_CHECKOUT_MODAL_VIEW_CONTROL]: 'New Checkout Modal View - Control',
  [EVENTS.NEW_CHECKOUT_MODAL_VIEW_VARIANT]: 'New Checkout Modal View - Variant',
  [EVENTS.PAYMENT_SELECT_CLICK]: 'Payment Select Click',
  [EVENTS.PAYMENT_SUBMIT_CLICK]: 'Payment Submit Click',
  [EVENTS.CHECKOUT_SUCCESS]: 'Checkout Success',
  [EVENTS.CHECKOUT_ERROR]: 'Checkout Error',
  [EVENTS.PAID_SUCCESS]: 'Paid Success',
  [EVENTS.ATP_CROSS_SELL_MODAL_CLICK]: 'ATP Cross-Sell Modal Click',
  [EVENTS.BUY_ADDON_CLICK]: 'Buy Add-on Click',
  [EVENTS.UNLOADED_REPORT_VIEW]: 'Unloaded Report View',
  [EVENTS.LOADED_REPORT_VIEW]: 'Loaded Report View',
  [EVENTS.PROJECT_CREATION_CLICK]: 'Project Creation Click',
  [EVENTS.PROJECT_CREATION_SUCCESS]: 'Project Creation Success',
  [EVENTS.CANCEL_SUBSCRIPTION_SUCCESS]: 'Cancel Subscription Success',
  [EVENTS.VIEW_REPORT]: 'View Report',
  [EVENTS.UPDATE_BILLING_INFORAMTION_UPDATED]:
    'Update Billing Information Updated',
  [EVENTS.DASHBOARD_LANDING_PAGE_CONTROL]:
    'experiment_landing_page_dashboard_control',
  [EVENTS.DASHBOARD_LANDING_PAGE_VARIANT]:
    'experiment_landing_page_dashboard_variant',
  [EVENTS.MONTHLY_TIER_1_PRICE_EXPERIMENT_CONTROL]:
    'experiment_reduceprice_monthlytier1_v2_control',
  [EVENTS.MONTHLY_TIER_1_PRICE_EXPERIMENT_VARIANT]:
    'experiment_reduceprice_monthlytier1_v2_variant',
} as const
